import { createGlobalStyle } from 'styled-components';
import { TokenSet } from './tokens';

export const GlobalStyles = createGlobalStyle<{ tokens: TokenSet }>`
  *, *::before, *::after {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html, body, button, input, textarea, select {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
  }

  body {
    background: ${p => p.tokens.bg};
    color: ${p => p.tokens.text};
    min-height: 100vh;
    transition: background 0.3s ease, color 0.3s ease;
    position: relative;
  }

  #root {
    position: relative;
    z-index: 1;
    min-height: 100vh;
  }

  a {
    color: ${p => p.tokens.primary};
    text-decoration: none;
  }

  button {
    cursor: pointer;
    border: none;
    outline: none;
    font-family: inherit;
  }

  input, textarea {
    font-family: inherit;
    outline: none;
  }

  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  ::-webkit-scrollbar-track {
    background: ${p => p.tokens.bgSurface};
  }

  ::-webkit-scrollbar-thumb {
    background: ${p => p.tokens.primary};
    border-radius: 3px;
  }
`;
